module.exports = __webpack_public_path__ + "img/needle-step-3.1ad9bcac.png";